import { Button } from 'admin/components/atoms/Buttons';
import LabeledTextBox from 'admin/components/molecules/LabeledTextBox';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';
import type { OrganizationsQueryParams } from '.';

type Query = {
  name: string | undefined;
};

type Props = {
  query: Query;
  onSearch: (query: Query) => void;
  onClear: () => void;
};

type FormFilterParams = OrganizationsQueryParams;

const SectionWrapper = styled.div``;
const FilterFormWrapper = styled.div`
  display: flex;
`;

const FormActions = styled.div`
  display: flex;
  margin: 8px 0px 16px;
  gap: 10px;
`;

const LabelText = styled.span``;

const removeEmptyKeysFromQuery = (obj: Record<string, unknown>): Query => {
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => v != null)) as Query;
};

const MemberOrganizationFilterForm = ({ query, onSearch, onClear }: Props) => {
  const defaultValues = {
    name: query.name ?? '',
  };

  const { handleSubmit, reset, register } = useForm<FormFilterParams>({
    defaultValues,
  });

  const onSubmit = (data: FormFilterParams) => {
    onSearch(removeEmptyKeysFromQuery({ ...data, page: 1 }));
  };

  useEffect(() => {
    reset({
      name: query.name ?? '',
    });
  }, [query, reset]);

  return (
    <SectionWrapper>
      <FilterFormWrapper>
        <LabeledTextBox labelText={<LabelText>組織名</LabelText>} {...register('name')} />
      </FilterFormWrapper>
      <FormActions>
        <Button
          variant="neutral"
          onClick={() => {
            onClear();
            reset({ ...defaultValues });
          }}
        >
          クリア
        </Button>
        <Button onClick={handleSubmit(onSubmit)}>検索</Button>
      </FormActions>
    </SectionWrapper>
  );
};

export default MemberOrganizationFilterForm;
